import React from "react";
import * as styles from "./FeedbackForm.module.scss";
import classNames from "classnames";
import FormBuilder from "@app/components/FormBuilder";
import fieldsets from "./feedback-fieldsets.json";
import Button from "@app/components/Button";
import { getFormStepErrors } from "@app/utils/inspection";
import { useFetcher, useRouteLoaderData } from "react-router-dom";
import Hint from "@app/components/Hint";
import useOnline from "@app/lib/hooks/useOnline";
import { format } from "date-fns";

const FeedbackForm = ({ variant }) => {
	const FeedbackFormClassName = classNames({
		[styles["feedback-form"]]: true,
		[styles["feedback-form__inline"]]: variant === "inline",
	});
	const fetcher = useFetcher();
	const isOnline = useOnline();
	const { office, userProfile } = useRouteLoaderData("root");
	const onSubmit = (values) => {
		let submitValues = Object.entries(values)
			.filter(([key]) => !key.startsWith("__"))
			.reduce(
				(res, [key, value]) => ({
					...res,
					[key]: value,
				}),
				{},
			);
		submitValues.name = `${userProfile?.firstName} ${userProfile.lastName}`;
		submitValues.office = office?.Branch;
		submitValues.createdAt = format(new Date(), "yyyy-MM-dd HH:mm:ss");
		fetcher.submit(submitValues, {
			method: "post",
			action: "/feedback",
		});
	};

	return (
		<div className={FeedbackFormClassName}>
			{fetcher.data?.ok && (
				<div className="my-120 text-center">
					<h1>Vielen Dank für Ihr Feedback!</h1>
					<p>
						Ihr Feedback und Ihre Verbesserungsvorschläge helfen uns dabei, die Qualität unserer internen
						Anwendung kontinuierlich zu verbessern.
					</p>
				</div>
			)}
			{!fetcher.data?.ok && (
				<FormBuilder
					id={"feedback-form"}
					key={"feedback-form"}
					values={{
						__variant: variant,
					}}
					finalSeparator={false}
					fieldsets={fieldsets.fieldsets}
					onSubmit={(values) => {
						onSubmit(values);
					}}
					Navigation={({ formikProps }) => {
						const errors = getFormStepErrors(fieldsets, formikProps.values, false);

						const label = fetcher.state === "loading" ? "Feedback wird gesendet..." : "Feedback senden";

						return (
							<div className={"mt-30"}>
								{fetcher.data && !fetcher.data.ok && (
									<Hint
										className={"mb-18"}
										label={"Server-Fehler: Das Feedback konnte leider nicht gesendet werden."}
										simple={false}
									/>
								)}
								{!isOnline && (
									<Hint
										className={"mb-18"}
										label={"Feedback kann nicht offline versendet werden."}
										simple={false}
									/>
								)}
								<Button
									type={"primary"}
									label={label}
									isSubmit={true}
									disabled={errors.length > 0 || !isOnline}
								/>
							</div>
						);
					}}
					isOverlay={true}
				/>
			)}
		</div>
	);
};

FeedbackForm.propTypes = {};

export default FeedbackForm;
